import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  useToast
} from '@chakra-ui/react'
import { AnalyticsService } from '../services/analytics'

interface CourtSelectionModalProps {
  isOpen: boolean
  onClose: () => void
  onCourtSelected: (courtNumber: number) => void
  maxCourts: number
  userEmail: string
}

export const CourtSelectionModal: React.FC<CourtSelectionModalProps> = ({
  isOpen,
  onClose,
  onCourtSelected,
  maxCourts,
  userEmail
}) => {
  const toast = useToast()

  const handleCourtSelection = async (courtNumber: number) => {
    // Log analytics event
    await AnalyticsService.logCourtSelected(courtNumber)
    
    onCourtSelected(courtNumber)
    onClose()
  }

  const renderCourtButtons = () => {
    const buttons = []
    for (let i = 1; i <= maxCourts; i++) {
      buttons.push(
        <Button
          key={i}
          size="lg"
          colorScheme="blue"
          variant="outline"
          onClick={() => handleCourtSelection(i)}
          width="200px"
          height="60px"
          fontSize="xl"
          fontWeight="bold"
          borderRadius={3}
          borderColor="blue.400"
          color="blue.400"
          _hover={{
            borderColor: "blue.300",
            color: "blue.300"
          }}
        >
          Court {i}
        </Button>
      )
    }
    return buttons
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent bg="#09090b" color="white" maxW="500px">
        <ModalHeader textAlign="center" borderBottom="1px solid" borderColor="gray.700">
          Select Your Court
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody pb={6}>
          <VStack spacing={4} align="center">
            <VStack spacing={3} width="100%">
              {renderCourtButtons()}
            </VStack>
            <Text fontSize="xs" color="gray.500" textAlign="center" mt={4}>
              Only one active match per court is allowed
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
